// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_7vA","cls2":"LettersModal-cls2__8h LettersModal-cls1_7vA"};